import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function AdminCustomOrders() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/custom-orders").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-custom-orders">
      <h1 className="font-display font-extrabold text-3xl md:text-4xl">Custom Order Requests</h1>
      <p className="text-gray-500 mt-1 text-sm mb-6">{items.length} requests</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {items.map(o => (
          <div key={o.id} className="bg-white border border-gray-100 rounded-2xl p-5" data-testid={`custom-request-${o.id}`}>
            <div className="flex items-center justify-between mb-3">
              <div>
                <p className="font-display font-extrabold text-lg">{o.name}</p>
                <p className="text-xs text-gray-500">{o.event_type} · {o.event_date}</p>
              </div>
              <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-700 font-bold uppercase">{o.status}</span>
            </div>
            <DL k="Quantity" v={o.quantity} />
            <DL k="Preferred Flavors" v={o.preferred_flavors} />
            <DL k="Custom Writing" v={o.custom_writing} />
            <DL k="Theme" v={o.theme_notes} />
            <DL k="Inspiration" v={o.inspiration_photos} />
            <DL k="Additional Notes" v={o.additional_notes} />
            <p className="text-[10px] text-gray-400 mt-3">{new Date(o.created_at).toLocaleString()}</p>
          </div>
        ))}
        {items.length === 0 && <p className="text-gray-500 text-sm">No custom requests yet.</p>}
      </div>
    </div>
  );
}

function DL({ k, v }) {
  if (!v) return null;
  return (
    <div className="text-sm py-1"><span className="text-xs uppercase tracking-widest font-bold text-[#FF1F87]">{k}:</span> {v}</div>
  );
}
